import { ReactNode } from "react";

import PageInfoHeaderCaption from "ds/components/PageInfoHeader/Caption";
import PageInfoHeaderTitle from "ds/components/PageInfoHeader/Title";
import PageInfoHeaderWrapper from "ds/components/PageInfoHeader/Wrapper";
import Box from "ds/components/Box";

type ScanSettingsPageLayoutProps = {
  children: ReactNode;
  title: string;
  description?: string;
};

const ScanSettingsPageLayout = ({ children, title, description }: ScanSettingsPageLayoutProps) => {
  return (
    <Box direction="column" grow="1" zeroMinHeight>
      <PageInfoHeaderWrapper align="start">
        <Box direction="column">
          <PageInfoHeaderTitle title={title} />
          {description && <PageInfoHeaderCaption caption={description} />}
        </Box>
      </PageInfoHeaderWrapper>

      {children}
    </Box>
  );
};

export default ScanSettingsPageLayout;
